import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68030448"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("初始化菜单")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增管理员")
const _hoisted_3 = {
  key: 0,
  class: "action_btn_box"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("已禁用"))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("已启用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("启用 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "管理员管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.initMenu,
          style: {"margin-right":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.addOrUpdateAdmin
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'roles' && text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(text, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_tag, {
                  class: "action_btn",
                  color: "orange",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.role.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (column.key === 'avatar' && text)
          ? (_openBlock(), _createBlock(_component_a_image, {
              key: 1,
              src: _ctx.getImageUrl(text),
              width: 80
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (column.key === 'disable')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              text
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "red"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "green"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (!record.disable)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    title: "是否禁用管理员?",
                    okButtonProps: {danger: true},
                    onConfirm: ($event: any) => (_ctx.changeAdminStatus(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        danger: "",
                        size: "small",
                        type: "primary",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.changeAdminStatus(record)),
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.addOrUpdateAdmin(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}